module.exports = __webpack_public_path__ + "img/blend1icon4.b6bbed02.png";